export const FIELD_VERTICAL_SPACING = 30;

export const TypeItems = [
  { value: 'string', label: 'String' },
  { value: 'password', label: 'Password' },
];
